<template lang="pug">
.bg-page
  #containerW.container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
    .mb-5
    section
      .section-title wirforce
      .mb-3
      iframe(src="https://player.twitch.tv/?channel=wirforce", frameborder="0", allowfullscreen="true", scrolling="no", :width="iframeW", :height="iframeH")
        a(href="https://www.twitch.tv/wirforce?tt_medium=live_embed&tt_content=text_link", style="padding:2px 0px 4px; display:block; width:345px; font-weight:normal; font-size:10px; text-decoration:underline;") 在 www.twitch.tv 觀賞 wirforce 的實況。
      .mb-10
      .section-title wirforce_byoc
      .mb-3
      iframe(src="https://player.twitch.tv/?channel=wirforce_byoc", frameborder="0", allowfullscreen="true", scrolling="no", :width="iframeW", :height="iframeH")
        a(href="https://www.twitch.tv/wirforce_byoc?tt_medium=live_embed&tt_content=text_link", style="padding:2px 0px 4px; display:block; width:345px; font-weight:normal; font-size:10px; text-decoration:underline;") 在 www.twitch.tv 觀賞 wirforce_byoc 的實況。
    section
    .mb-60
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'onAir',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
      iframeW: 0,
      iframeH: 0
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
    explantion (ticketType) {
      switch (ticketType) {
        case '潛水區':
          this.$swal({
            title: '潛水區說明',
            html: '<div>＊潛水區說明：該區域限定位子在 D區。<br> WirForce 活動期間不會有廠商活動在該區進行。</div>',
            confirmButtonText: '返回'
          })
          break
        case 'VIP':
          this.$swal({
            title: 'VIP 說明',
            html: '<div>＊需經過官方通知與審核方可通過此區方案。</div>',
            confirmButtonText: '返回'
          })
          break
        case '身障票':
          this.$swal({
            title: '身障票 說明',
            html: '<div>＊需經過官方通知與審核方可通過此區方案。</div>',
            confirmButtonText: '返回'
          })
          break
      }
    }
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
    if (window.getComputedStyle(document.getElementById('containerW')).paddingLeft) {
      let windowPadding = window.getComputedStyle(document.getElementById('containerW')).paddingLeft.split('px')[0]
      this.iframeW = document.getElementById('containerW').offsetWidth - (windowPadding * 2)
      this.iframeH = (document.getElementById('containerW').offsetWidth / 1.7815384615) - (windowPadding * 2)
    } else {
      this.iframeW = document.getElementById('containerW').offsetWidth
      this.iframeH = document.getElementById('containerW').offsetWidth / 1.7815384615
    }
    window.addEventListener('resize', () => {
      console.log('padding:', window.getComputedStyle(document.getElementById('containerW')).paddingLeft.split('px')[0])
      if (window.getComputedStyle(document.getElementById('containerW')).paddingLeft) {
        let windowPadding = window.getComputedStyle(document.getElementById('containerW')).paddingLeft.split('px')[0]
        this.iframeW = document.getElementById('containerW').offsetWidth - (windowPadding * 2)
        this.iframeH = (document.getElementById('containerW').offsetWidth / 1.7815384615) - (windowPadding * 2)
      } else {
        this.iframeW = document.getElementById('containerW').offsetWidth
        this.iframeH = document.getElementById('containerW').offsetWidth / 1.7815384615
      }
    }, false)
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
</style>



// WEBPACK FOOTER //
// onAir.vue?db52ebc8